import React, { useState, useEffect } from 'react';

const calculateTimeLeft = (targetDate) => {
  const difference = new Date(targetDate) - new Date();

  if (difference <= 0) {
    return null;
  }

  return {
    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
    hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((difference / 1000 / 60) % 60),
    seconds: Math.floor((difference / 1000) % 60)
  };
};

function CountdownTimer({ targetDate, label = "Picks close in" }) {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(targetDate));

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft(targetDate));
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  if (!timeLeft) {
    return (
      <div className="countdown-timer countdown-expired">
        <span className="countdown-label">Picks are closed</span>
      </div>
    );
  }

  // Urgent if less than 1 hour to lock
  const isUrgent = timeLeft.days === 0 && timeLeft.hours === 0;

  return (
    <div className={`countdown-timer${isUrgent ? ' countdown-urgent' : ''}`}>
      <span className="countdown-label">{label}</span>
      <div className="countdown-time">
        {timeLeft.days > 0 && (
          <span className="countdown-unit">
            <span className="countdown-value">{timeLeft.days}</span>
            <span className="countdown-suffix">d</span>
          </span>
        )}
        <span className="countdown-unit">
          <span className="countdown-value">{String(timeLeft.hours).padStart(2, '0')}</span>
          <span className="countdown-suffix">h</span>
        </span>
        <span className="countdown-unit">
          <span className="countdown-value">{String(timeLeft.minutes).padStart(2, '0')}</span>
          <span className="countdown-suffix">m</span>
        </span>
        <span className="countdown-unit">
          <span className="countdown-value">{String(timeLeft.seconds).padStart(2, '0')}</span>
          <span className="countdown-suffix">s</span>
        </span>
      </div>
    </div>
  );
}

export default CountdownTimer;
